import "../../assets/css/panel-tile.css";
import PropTypes from 'prop-types';

const PanelTile = (props) => {
  const {
    children,
    imageUrl = "",
    renderImage = null,
    headerContent = null,
    classList,
    alt = "",
    caption = "",
  } = props;

  return (
    <div
      className={`panel panel-default panel--photo tile sg-tile ${classList}`}
    >
      {!!headerContent ? (
        <p className="tile__title gallery__heading gallery__heading--community-photo">
          {headerContent}
        </p>
      ) : null}
      {!!imageUrl ? (
        <img className="tile__img" src={imageUrl} alt={alt} />
      ) : null}
      {!!renderImage ? renderImage() : null}
      {caption ? (
        <p className="tile__caption gallery__description">{caption}</p>
      ) : null}
      <div className="tile__description gallery__description">{children}</div>
    </div>
  ); 
};

PanelTile.defaultProps = {
  classList: "",
};

PanelTile.propTypes = {
  imageUrl: PropTypes.string,
  classList: PropTypes.string
};

export default PanelTile;